import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "snack-form" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Nama Bundle Snack", -1)
const _hoisted_4 = { class: "invalid-feedback" }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Kode Bundle Snack", -1)
const _hoisted_7 = { class: "invalid-feedback" }
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Kategori", -1)
const _hoisted_10 = { class: "invalid-feedback" }
const _hoisted_11 = { class: "mb-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Harga Bundle", -1)
const _hoisted_13 = { class: "p-inputgroup flex-1" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Rp.", -1)
const _hoisted_15 = { class: "invalid-feedback" }
const _hoisted_16 = { class: "flex items-center gap-3 mb-4" }
const _hoisted_17 = { class: "w-full md:w-1/3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Diskon", -1)
const _hoisted_19 = { class: "p-inputgroup flex-1" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "%", -1)
const _hoisted_21 = { class: "invalid-feedback" }
const _hoisted_22 = { class: "w-full md:w-2/3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Setelah Diskon", -1)
const _hoisted_24 = { class: "p-inputgroup flex-1" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Rp.", -1)
const _hoisted_26 = { class: "invalid-feedback" }
const _hoisted_27 = { class: "mb-4" }
const _hoisted_28 = { class: "flex items-end gap-3" }
const _hoisted_29 = { class: "w-full md:w-1/2" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Komisi Penjualan di HJKru", -1)
const _hoisted_31 = { class: "p-inputgroup flex-1" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Rp.", -1)
const _hoisted_33 = { class: "invalid-feedback" }
const _hoisted_34 = { class: "w-full md:w-1/2" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Komisi Penjualan di luar HJKru", -1)
const _hoisted_36 = { class: "p-inputgroup flex-1" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Rp.", -1)
const _hoisted_38 = { class: "invalid-feedback" }
const _hoisted_39 = { class: "invalid-feedback" }
const _hoisted_40 = { class: "mb-4" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", {
  for: "Description",
  class: "label-text required"
}, "Keterangan", -1)
const _hoisted_42 = { class: "invalid-feedback" }
const _hoisted_43 = { class: "mb-4" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", {
  for: "thumbnail",
  class: "label-text required"
}, "Thumbnail Bundle Snack", -1)
const _hoisted_45 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { class: "mt-3 flex gap-x-2 items-center" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-upload font-black text-sm" }, null, -1)
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" Upload Gambar ")
const _hoisted_50 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times color-danger text-sm" }, null, -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("p", { class: "color-danger font-extrabold" }, "Hapus", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", { class: "label-text" }, "Tampilkan di Aplikasi", -1)
const _hoisted_53 = { class: "mb-4" }
const _hoisted_54 = { class: "flex align-items-center" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", {
  for: "IsShowHjKru",
  class: "ml-2"
}, " HJKru (Aplikasi Kondektur) ", -1)
const _hoisted_56 = { class: "mb-4" }
const _hoisted_57 = { class: "flex align-items-center" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", {
  for: "IsShowHjApps",
  class: "ml-2"
}, " HJPrima (Aplikasi Penumpang) ", -1)
const _hoisted_59 = { class: "mb-4" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm mb-1" }, "Aktif", -1)
const _hoisted_61 = { class: "container-btn-action" }
const _hoisted_62 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_63 = /*#__PURE__*/_createTextVNode("Simpan")

import { Form, Field, FieldArray, ErrorMessage } from 'vee-validate'
import vSelect from 'vue-select'
import * as Yup from 'yup'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Textarea from 'primevue/textarea'
import InputSwitch from 'primevue/inputswitch'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import apiUseCase from '@/usecase/apiUseCase'
import rgxExp from '@/utils/helpers/regExp'
import { getCurrentInstance, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import SelectAsyncOpen from '@/views/components/form/SelectAsyncOpen.vue'
import apiOpenUseCase from '@/usecase/apiOpenUseCase'
import InputNumber from 'primevue/inputnumber'
import ButtonFileUpload from '@/views/components/button/FileUpload.vue'
import { useRoute } from 'vue-router'
import Checkbox from 'primevue/checkbox'
import apiImageUseCase from '@/usecase/apiImageUseCase'


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const snackEndpoint = '/ticket/v1/Snacks'
const store = useStore()
const route = useRoute()
const maxSizeFile = 1024 * 1024 * 1
const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties
const currentData = ref(null) as any
const dataForm = ref()
const tempImage = ref(null) as any
const isImageChange = ref(false)

const getImageName = (name: string) => {
  const nameTemp = name.split('/')
  return nameTemp[nameTemp.length - 1]
}

const initialValues = {
  Name: store.state.hjpTable.modal?.data?.Name ?? null,
  Code: store.state.hjpTable.modal?.data?.Code ?? null,
  Category: store.state.hjpTable.modal?.data?.CategoryId ? {
    Id: store.state.hjpTable.modal?.data?.CategoryId,
    Name: store.state.hjpTable.modal?.data?.CategoryName,
    label: store.state.hjpTable.modal?.data?.CategoryName,
    value: store.state.hjpTable.modal?.data?.CategoryId
  } : null,
  Price: store.state.hjpTable.modal?.data?.Price ?? null,
  ConductorCommision: store.state.hjpTable.modal?.data?.CondecturCommission ?? 0,
  NonConductorCommision: store.state.hjpTable.modal?.data?.NonCondecturCommission ?? 0,
  IsShowHjKru: store.state.hjpTable.modal?.data?.IsShowHJKru ?? false,
  IsShowHjApps: store.state.hjpTable.modal?.data?.IsShowHJApps ?? false,
  Discount: store.state.hjpTable.modal?.data?.Discount ?? 0,
  PriceAfterDiscount: store.state.hjpTable.modal?.data?.Discount >= 0 ? (store.state.hjpTable.modal?.data?.Price - (store.state.hjpTable.modal?.data?.Price * (store.state.hjpTable.modal?.data?.Discount / 100))) : 0,
  Description: store.state.hjpTable.modal?.data?.Description ?? '',
  Image: store.state.hjpTable.modal?.data?.Image ? {
    blob: store.state.hjpTable.modal?.data?.Image,
    name: getImageName(store.state.hjpTable.modal?.data?.Image)
  } : null,
  IsActive: store.state.hjpTable.modal?.data?.IsActive ?? true
}

const schema = Yup.object().shape({
  Name: Yup.string()
    .required('Nama Snack harus diisi!')
    .min(3, 'Nama Snack minimal 3 karakter')
    .max(150, 'Nama Snack maksimal 150 karakter')
    .matches(rgxExp.notPrefixSpace, 'Nama Snack tidak boleh hanya menggunakan spasi')
    .matches(rgxExp.noSpecialChar, 'Kode Snack tidak boleh menggunakan karakter spesial')
    .test('unique-name', 'Nama Snack sudah digunakan', async (val) => {
      if (!val) return true
      try {
        const res = await apiOpenUseCase.get(`${snackEndpoint}${returnUrlPrams({
          search: val,
          filterField: ['q']
        })}`)
        const filterResult = res.result.filter((x: any) => x.Name.toLowerCase() === val.toLowerCase())
        if (currentData.value) {
          return filterResult.length === 0 || val.toLowerCase() === initialValues.Name.toLowerCase()
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
  Code: Yup.string()
    .required('Kode Snack harus diisi!')
    .min(3, 'Kode Snack minimal 3 karakter')
    .max(5, 'Kode Snack maksimal 5 karakter')
    .matches(rgxExp.notPrefixSpace, 'Kode Snack tidak boleh hanya menggunakan spasi')
    .matches(rgxExp.noWhiteSpaceAndSpecialChar, 'Kode Snack tidak boleh menggunakan spasi dan karakter spesial')
    .test('unique-code', 'Kode Snack sudah digunakan', async (val) => {
      if (!val) return true
      try {
        const res = await apiOpenUseCase.get(`${snackEndpoint}${returnUrlPrams({
          search: val,
          filterField: ['q']
        })}`)
        const filterResult = res.result.filter((x: any) => x.Code.toLowerCase() === val.toLowerCase())
        if (currentData.value) {
          return filterResult.length === 0 || val.toLowerCase() === initialValues.Code.toLowerCase()
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
  Category: Yup.object().required('Kategori harus diisi!'),
  Image: Yup.object().required('Thumbnail Snack harus diisi!'),
  Price: Yup.number()
    .typeError('Harga harus diisi!')
    .required('Harga harus diisi!')
    .min(1, 'Harga harus diatas 0')
    .test('maxDigits', 'Harga tidak valid', (value) => {
      const valConfert = value.toString()
      if (!valConfert) return true
      const numberRegex = /^\d{1,8}(\.\d{1,2})?$/
      return numberRegex.test(valConfert)
    }),
  Discount: Yup.number()
    .typeError('Diskon harus diisi!')
    .required('Diskon harus diisi!')
    .min(0, 'Diskon minimal 0')
    .max(100, 'Diskon maksimal 100')
    .test('maxDigits', 'Diskon tidak valid', (value) => {
      const valConfert = value.toString()
      if (!valConfert) return true
      const numberRegex = /^\d{1,8}(\.\d{1,2})?$/
      return numberRegex.test(valConfert)
    }),
  PriceAfterDiscount: Yup.number()
    .typeError('Harga Setelah Diskon harus diisi!')
    .required('Harga Setelah Diskon harus diisi!')
    .min(0, 'Harga Setelah Diskon minimal 0')
    .test('maxDigits', 'Harga Setelah Diskon tidak valid', (value) => {
      value = Math.round(value)
      const valConfert = value.toString()
      // console.log('valConfert', valConfert)
      if (!valConfert) return true
      const numberRegex = /^\d{1,8}(\.\d{1,2})?$/
      // console.log(numberRegex.test(valConfert))
      return numberRegex.test(valConfert)
    }),
  ConductorCommision: Yup.number()
    // .typeError('Komisi harus diisi!')
    // .required('Komisi harus diisi!')
    .min(0, 'Komisi minimal 0')
    .test('maxDigits', 'Komisi tidak valid', (value) => {
      const valConfert = value?.toString()
      if (!valConfert) return true
      const numberRegex = /^\d{1,8}(\.\d{1,2})?$/
      return numberRegex.test(valConfert)
    }),
  NonConductorCommision: Yup.number()
    // .typeError('Komisi harus diisi!')
    // .required('Komisi harus diisi!')
    .min(0, 'Komisi minimal 0')
    .test('maxDigits', 'Komisi tidak valid', (value) => {
      const valConfert = value?.toString()
      if (!valConfert) return true
      const numberRegex = /^\d{1,8}(\.\d{1,2})?$/
      return numberRegex.test(valConfert)
    }),
  Description: Yup.string()
    .required('Keterangan harus diisi!')
    .matches(rgxExp.notPrefixSpace, 'Keterangan tidak boleh hanya menggunakan spasi.')
    .min(5, 'Keterangan minimal 5 karakter')
    .max(255, 'Keterangan maksimal 255 karakter')
}).test('total-komisi', 'Komisi tidak boleh lebih besar dari Harga Setelah Diskon', function (this: Yup.TestContext, values) {
  console.log('hehe', values)
  if (!values) return true
  const { PriceAfterDiscount, ConductorCommision, NonConductorCommision } = values
  if (
    PriceAfterDiscount == null || ConductorCommision == null || NonConductorCommision == null
  ) {
    return true
  }

  // return NonConductorCommision + ConductorCommision <= PriceAfterDiscount
  if ((NonConductorCommision + ConductorCommision) > PriceAfterDiscount) {
    return this?.createError({
      path: 'Komisi', // <- tampil di field ini
      message: 'Total Komisi tidak boleh lebih besar dari Harga Setelah Diskon'
    })
  }

  return true
})

const onInputFile = (file: any, setFieldValue: any) => {
  /* eslint-disable */
  if (file) {
    const totalSize: number = Number((file.size / 1024 / 1024).toFixed(1))
    if (totalSize > 1) {
      $toast.add({
        severity: 'error',
        detail: 'Ukuran file lebih dari 1MB.',
        group: 'bc',
        closable: false,
        life: 3000
      })
    } else {
      /* eslint-disable-next-line */
      if (file) {
        setFieldValue('Image', { file: file.file, name: file.name, blob: file.blob })
      }
    }
    isImageChange.value = true
  }
}

const openDetailImg = (fileUrl: string) => {
  window.open(fileUrl, '_blank')
}

const hideSidebar = () => {
  store.dispatch('setShowModalFormDl', false)
  store.dispatch('storeRowDataTable', null)
}

const processUpload: string | null | any = async (file: any) => {
  const payload = new FormData()
  payload.append('file', file)
  // const response = await apiUseCase.postOrPut('media/Upload', null, payload)
  const response = await apiImageUseCase.postOrPut('api/v1/assets', null, payload)
  if (!response.error) {
    return response.result.path
  }
  return null
}

const processSubmit = async () => {
  store.dispatch('showLoading')
  try {
    let thumbnailTemp = null
    if (isImageChange.value) {
      // let messageSuccess = `Berhasil buat ${condecturOrController.toLocaleLowerCase()}`
      if (dataForm.value.Image && typeof dataForm.value.Image === 'object') {
        thumbnailTemp = await processUpload(dataForm.value.Image.file)
      }
      // console.log([typeof dataForm.value.Image === 'object', dataForm.value.Image])
      // Payload file when edit
      if (route.params?.id) {
        if (tempImage.value && !dataForm.value.Image) {
          thumbnailTemp = typeof dataForm.value.Image === 'object' ? tempImage.value.filePath : dataForm.value.Image
        }
      }
    }

    const payload = await {
      ...dataForm.value,
      SnackCategoryId: dataForm.value?.Category?.Id,
      Name: dataForm.value?.Name,
      Code: dataForm.value?.Code,
      Image: thumbnailTemp ?? currentData.value?.ImageOrigin,
      Description: dataForm.value?.Description,
      IsActive: dataForm.value?.IsActive,
      Price: dataForm.value?.Price,
      Discount: dataForm.value?.Discount,
      CurrentQuantity: 0,
      SnackCommisions: [
        { SalesChannel: 'Conductor', CommissionValue: dataForm.value?.ConductorCommision },
        { SalesChannel: 'MobileApp', CommissionValue: dataForm.value?.NonConductorCommision },
      ],
      SnackChannels: [
        { SalesChannel: 'Conductor', IsActive: dataForm.value?.IsShowHjKru },
        { SalesChannel: 'MobileApp', IsActive: dataForm.value?.IsShowHjApps },
      ]
    }
    // console.log('payload', payload)
    await apiOpenUseCase.postOrPut(snackEndpoint, currentData.value?.Id, payload).then((response) => {
      const { error, result, message } = response
      if (!error) {
        $toast.add({
          severity: 'success',
          detail: `Data Snack Berhasil ${currentData.value ? 'Diubah' : 'Ditambahkan'}`,
          group: 'bc',
          closable: false,
          life: 3000
        })
        store.dispatch('setReloadDataTable', true)
        hideSidebar()
      } else {
        $toast.add({
          severity: 'error',
          summary: 'Gagal',
          detail: message,
          group: 'bc',
          closable: false,
          life: 3000
        })
      }
    })
    store.dispatch('hideLoading')
  } catch (error) {
    console.log('error', error)
    store.dispatch('hideLoading')
  }
}

const onSubmit = (values: any) => {
  // console.log('submit', values)
  dataForm.value = values
  processSubmit()
}

const handlePriceBlur = (fieldName: string, setFieldValue: any, values: any) => {
  // console.log('values', [values.Price, values.Discount, values.PriceAfterDiscount])
  if (fieldName === 'price') {
    if (values.Discount || values.Discount === 0) {
      // console.log('aaa')
      const newPriceAfterDiscount = values.Price - (values.Price * (values.Discount / 100))
      setFieldValue('PriceAfterDiscount', newPriceAfterDiscount)
    } else if (values.PriceAfterDiscount) {
      const newDiscount = ((values.Price - values.PriceAfterDiscount) / values.Price) * 100
      setFieldValue('Discount', newDiscount)
    }
  } else if (fieldName === 'discount') {
    if (values.Price) {
      const newPriceAfterDiscount = values.Price - (values.Price * (values.Discount / 100))
      setFieldValue('PriceAfterDiscount', newPriceAfterDiscount)
    } else if (values.PriceAfterDiscount) {
      const newPrice = values.PriceAfterDiscount / (1 - (values.Discount / 100))
      setFieldValue('Price', newPrice)
    }
  } else if (fieldName === 'priceNew') {
    if (values.Price) {
      const newDiscount = ((values.Price - values.PriceAfterDiscount) / values.Price) * 100
      setFieldValue('Discount', newDiscount)
    } else if (values.Discount && values.Discount === 0) {
      const newPrice = values.PriceAfterDiscount / (1 - (values.Discount / 100))
      setFieldValue('Price', newPrice)
    }
  }
}

onMounted(() => {
  console.log('store', store.state)
  currentData.value = store.state.hjpTable.modal?.data
  let titleForm = 'Tambah'
  if (store.state.hjpTable.modal?.data) {
    titleForm = 'Edit'
  }
  // checkAddOrUpdate()
  // console.log(initialValues)
  store.dispatch('setTitleFormSidebarDl', `${titleForm} Bundle Snack`)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Form), {
      onSubmit: onSubmit,
      "validation-schema": _unref(schema),
      "initial-values": initialValues,
      class: "form-container"
    }, {
      default: _withCtx(({ errors, setFieldValue, values, meta }) => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_unref(Field), { name: "Name" }, {
            default: _withCtx(({ field, handleChange, handleBlur }) => [
              _createVNode(_unref(InputText), _mergeProps(field, {
                modelValue: values.Name,
                "onUpdate:modelValue": ($event: any) => ((values.Name) = $event),
                onChange: handleChange,
                onBlur: handleBlur,
                id: "Name",
                class: `${errors.Name ? 'input-invalid' : ''}`,
                placeholder: "Tulis Nama Snack"
              }), null, 16, ["modelValue", "onUpdate:modelValue", "onChange", "onBlur", "class"])
            ]),
            _: 2
          }, 1024),
          _createElementVNode("div", _hoisted_4, _toDisplayString(errors.Name), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_unref(Field), { name: "Code" }, {
            default: _withCtx(({ field, handleChange, handleBlur }) => [
              _createVNode(_unref(InputText), _mergeProps(field, {
                modelValue: values.Code,
                "onUpdate:modelValue": ($event: any) => ((values.Code) = $event),
                onChange: handleChange,
                onBlur: handleBlur,
                id: "Code",
                class: `${errors.Code ? 'input-invalid' : ''}`,
                placeholder: "Tulis Kode Snack",
                maxlength: 5,
                style: {"text-transform":"uppercase"}
              }), null, 16, ["modelValue", "onUpdate:modelValue", "onChange", "onBlur", "class"])
            ]),
            _: 2
          }, 1024),
          _createElementVNode("div", _hoisted_7, _toDisplayString(errors.Code), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_unref(Field), { name: "Category" }, {
            default: _withCtx(({ field }) => [
              _createVNode(SelectAsyncOpen, {
                placeholder: 'Pilih Kategori',
                modelValue: values.Category,
                "onUpdate:modelValue": ($event: any) => ((values.Category) = $event),
                id: 'category',
                inputId: 'category',
                endpoint: "/ticket/v1/Snacks/Categories",
                classname: 'custom-select',
                disabled: false,
                fieldLabel: (v) => `${v.Name}`,
                clearable: false,
                searchFields: ['q']
              }, null, 8, ["modelValue", "onUpdate:modelValue", "fieldLabel"])
            ]),
            _: 2
          }, 1024),
          _createElementVNode("div", _hoisted_10, _toDisplayString(errors.Category), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_unref(Field), {
            name: "Price",
            class: _normalizeClass(`input-primary ${errors.Price ? 'input-invalid' : ''}`)
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_unref(InputNumber), {
                  modelValue: values.Price,
                  "onUpdate:modelValue": ($event: any) => ((values.Price) = $event),
                  class: _normalizeClass(`${errors.Price ? 'input-invalid' : ''}`),
                  id: "Price",
                  placeholder: "0",
                  min: 0,
                  currency: "IDR",
                  locale: "id-ID",
                  step: 0.25,
                  inputId: "refund-amount",
                  onInput: (v) => {
                setFieldValue('Price', v.value); handlePriceBlur('price', setFieldValue, values)
              },
                  allowEmpty: false,
                  autocomplete: "off"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "step", "onInput"])
              ])
            ]),
            _: 2
          }, 1032, ["class"]),
          _createElementVNode("div", _hoisted_15, _toDisplayString(errors.Price), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_unref(Field), {
              name: "Discount",
              class: _normalizeClass(`input-primary ${errors.Discount ? 'input-invalid' : ''}`)
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_unref(InputNumber), {
                    modelValue: values.Discount,
                    "onUpdate:modelValue": ($event: any) => ((values.Discount) = $event),
                    class: _normalizeClass(`${errors.Discount ? 'input-invalid' : ''}`),
                    id: "Discount",
                    placeholder: "0",
                    min: 0,
                    locale: "id-ID",
                    step: 0.25,
                    minFractionDigits: 2,
                    maxFractionDigits: 2,
                    inputId: "refund-amount",
                    onInput: (v) => {
                setFieldValue('Discount', v.value); handlePriceBlur('discount', setFieldValue, values)
              },
                    allowEmpty: false,
                    autocomplete: "off"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "step", "onInput"]),
                  _hoisted_20
                ])
              ]),
              _: 2
            }, 1032, ["class"]),
            _createElementVNode("div", _hoisted_21, _toDisplayString(errors.Discount), 1)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createVNode(_unref(Field), {
              name: "PriceAfterDiscount",
              class: _normalizeClass(`input-primary ${errors.PriceAfterDiscount ? 'input-invalid' : ''}`)
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode(_unref(InputNumber), {
                    modelValue: values.PriceAfterDiscount,
                    "onUpdate:modelValue": ($event: any) => ((values.PriceAfterDiscount) = $event),
                    class: _normalizeClass(`${errors.PriceAfterDiscount ? 'input-invalid' : ''}`),
                    id: "PriceAfterDiscount",
                    placeholder: "0",
                    min: 0,
                    currency: "IDR",
                    locale: "id-ID",
                    minFractionDigits: 0,
                    maxFractionDigits: 0,
                    inputId: "refund-amount",
                    onInput: (v) => {
                  setFieldValue('PriceAfterDiscount', v.value); handlePriceBlur('priceNew', setFieldValue, values)
                },
                    allowEmpty: false,
                    autocomplete: "off"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "onInput"])
                ])
              ]),
              _: 2
            }, 1032, ["class"]),
            _createElementVNode("div", _hoisted_26, _toDisplayString(errors.PriceAfterDiscount), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createVNode(_unref(Field), {
                name: "ConductorCommision",
                class: _normalizeClass(`input-primary ${errors.ConductorCommision ? 'input-invalid' : ''}`)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createVNode(_unref(InputNumber), {
                      modelValue: values.ConductorCommision,
                      "onUpdate:modelValue": ($event: any) => ((values.ConductorCommision) = $event),
                      class: _normalizeClass(`${errors.ConductorCommision ? 'input-invalid' : ''}`),
                      id: "ConductorCommision",
                      placeholder: "0",
                      min: 0,
                      currency: "IDR",
                      locale: "id-ID",
                      step: 0.25,
                      inputId: "refund-amount",
                      onInput: (v) => {
                    setFieldValue('ConductorCommision', v.value)
                  },
                      allowEmpty: false,
                      autocomplete: "off"
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "step", "onInput"])
                  ])
                ]),
                _: 2
              }, 1032, ["class"]),
              _createElementVNode("div", _hoisted_33, _toDisplayString(errors.ConductorCommision), 1)
            ]),
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createVNode(_unref(Field), {
                name: "NonConductorCommision",
                class: _normalizeClass(`input-primary ${errors.NonConductorCommision ? 'input-invalid' : ''}`)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createVNode(_unref(InputNumber), {
                      modelValue: values.NonConductorCommision,
                      "onUpdate:modelValue": ($event: any) => ((values.NonConductorCommision) = $event),
                      class: _normalizeClass(`${errors.NonConductorCommision ? 'input-invalid' : ''}`),
                      id: "NonConductorCommision",
                      placeholder: "0",
                      min: 0,
                      currency: "IDR",
                      locale: "id-ID",
                      step: 0.25,
                      inputId: "refund-amount",
                      onInput: (v) => {
                    setFieldValue('NonConductorCommision', v.value)
                  },
                      allowEmpty: false,
                      autocomplete: "off"
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "step", "onInput"])
                  ])
                ]),
                _: 2
              }, 1032, ["class"]),
              _createElementVNode("div", _hoisted_38, _toDisplayString(errors.NonConductorCommision), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_39, _toDisplayString(errors.Komisi), 1)
        ]),
        _createElementVNode("div", _hoisted_40, [
          _hoisted_41,
          _createVNode(_unref(Field), {
            id: "Description",
            name: "Description",
            as: "textarea",
            type: "text",
            placeholder: "Tulis Keterangan",
            class: _normalizeClass(`${errors.Description ? 'input-invalid' : ''}`),
            modelValue: values.Description,
            "onUpdate:modelValue": ($event: any) => ((values.Description) = $event),
            validateOnInput: true
          }, null, 8, ["class", "modelValue", "onUpdate:modelValue"]),
          _createElementVNode("div", _hoisted_42, _toDisplayString(errors.Description), 1)
        ]),
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          (meta.touched)
            ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(errors.Image), 1))
            : _createCommentVNode("", true),
          (values.Image?.blob || values.Image)
            ? (_openBlock(), _createElementBlock("p", {
                key: 1,
                class: "font-semibold cursor-pointer",
                onClick: ($event: any) => (openDetailImg(values.Image?.blob ?? values.Image))
              }, _toDisplayString(values.Image?.name), 9, _hoisted_46))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_47, [
            _createVNode(ButtonFileUpload, {
              inputId: "idFileKtp",
              size: maxSizeFile,
              onOnInputFile: (newFile, oldFile) => onInputFile(newFile, setFieldValue)
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Button), { class: "btn-back flex gap-x-2" }, {
                  default: _withCtx(() => [
                    _hoisted_48,
                    _hoisted_49
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onOnInputFile"]),
            (values.Image)
              ? (_openBlock(), _createBlock(_unref(Button), {
                  key: 0,
                  class: "btn-back gap-x-2 flex",
                  onClick: ($event: any) => (setFieldValue('Image', null))
                }, {
                  default: _withCtx(() => [
                    _hoisted_50,
                    _hoisted_51
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _hoisted_52,
        _createElementVNode("div", _hoisted_53, [
          _createVNode(_unref(Field), { name: "IsShowHjKru" }, {
            default: _withCtx(({ field }) => [
              _createElementVNode("div", _hoisted_54, [
                _createVNode(_unref(Checkbox), _mergeProps(field, {
                  modelValue: field.value,
                  "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                  binary: true,
                  inputId: "IsShowHjKru",
                  name: "IsShowHjKru"
                }), null, 16, ["modelValue", "onUpdate:modelValue"]),
                _hoisted_55
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_56, [
          _createVNode(_unref(Field), { name: "IsShowHjApps" }, {
            default: _withCtx(({ field }) => [
              _createElementVNode("div", _hoisted_57, [
                _createVNode(_unref(Checkbox), _mergeProps(field, {
                  modelValue: field.value,
                  "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                  binary: true,
                  inputId: "IsShowHjApps",
                  name: "IsShowHjApps"
                }), null, 16, ["modelValue", "onUpdate:modelValue"]),
                _hoisted_58
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_59, [
          _hoisted_60,
          _createVNode(_unref(Field), { name: "IsActive" }, {
            default: _withCtx(() => [
              _createVNode(_unref(InputSwitch), {
                class: "input-success",
                id: "isActive",
                modelValue: values.IsActive,
                "onUpdate:modelValue": ($event: any) => ((values.IsActive) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024)
        ]),
        _createElementVNode("div", _hoisted_61, [
          _createVNode(_unref(Button), {
            class: "btn-back mr-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (hideSidebar()))
          }, {
            default: _withCtx(() => [
              _hoisted_62
            ]),
            _: 1
          }),
          _createVNode(_unref(Button), {
            type: "submit",
            id: "Submit",
            class: "btn-primary mr-1"
          }, {
            default: _withCtx(() => [
              _hoisted_63
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["validation-schema"])
  ]))
}
}

})